import type { EnterpriseLBAApplicantInformationInterface } from '@/components/Applications/EnterpriseLBAForm/type';
import { formatDate3, formatNumber, formatPhoneNumber } from '../../../../../../utils';

interface IApplicantInformationDetailsProps {
  applicantInformation: EnterpriseLBAApplicantInformationInterface;
}
export default function ApplicantInformationDetails({ applicantInformation }: IApplicantInformationDetailsProps) {
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Applicant Information Details
            </h2>
            <p className='mt-1 max-w-2xl text-sm text-gray-500'>Applicant details and submission.</p>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Entity Name</dt>
              <dd className='mt-1 text-sm text-gray-900'>{applicantInformation.entityName}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Address</dt>
              <dd className='mt-1 text-sm text-gray-900'>
                {applicantInformation.streetAddress}, {applicantInformation.city}, {applicantInformation.state},{' '}
                {applicantInformation.zipCode}
              </dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Formation Date</dt>
              <dd className='mt-1 text-sm text-gray-900'>{formatDate3(applicantInformation.formationDate)}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Contact Person Name</dt>
              <dd className='mt-1 text-sm text-gray-900'>{applicantInformation.contactPersonName}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Contact Person Email</dt>
              <dd className='mt-1 text-sm text-gray-900'>{applicantInformation.contactPersonEmail}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Phone</dt>
              <dd className='mt-1 text-sm text-gray-900'>+1 {formatPhoneNumber(applicantInformation.phone)}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>EIN</dt>
              <dd className='mt-1 text-sm text-gray-900'>{applicantInformation.ein ? applicantInformation.ein : 'None'}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Website</dt>
              <dd className='mt-1 text-sm text-gray-900'>{applicantInformation.website}</dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Number of Full Time Employees</dt>
              <dd className='mt-1 text-sm text-gray-900'>{formatNumber(applicantInformation.fullTimeEmployeeCount)}</dd>
            </div>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>Following Apply</dt>
              <dd className='mt-1 text-sm text-gray-900'>
                {applicantInformation.anyApply.map((any: string) => (
                  <span key={any}>{any}, </span>
                ))}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}
